<template>

    <div :class="show ? 'brt-map-poiDetailModule show':'brt-map-poiDetailModule'" ref="poiDetailModule">

        <div class="wrap">

            <!--滑块区域-->
            <div :class="poiDetail.slideIMG ? 'top-slide-section':'top-slide-section mapshow'">

                <div class="box" v-if="poiDetail.slideIMG">
                    <Swipe class="brt-map-qsm-swipe" :options="swipeOptions" v-if="poiDetail.slideIMG">

                        <SwipeSlide class="brt-map-qsm-slide" v-for="item in poiDetail.slideIMG">

                            <div class="IMG-box"><img :src="item" alt="滑动图片" @click = 'slidIMG(item)'></div>

                        </SwipeSlide>

                    </Swipe>
                </div>

                <div class="close-box" @click="back"><i class="iconfont icon-down-01"></i></div>

            </div>


            <div class="content-box">

                <div class="go-here" @click="getRoute">
                    <i class="iconfont icon-route_01"></i>
                    <p>到这去</p>
                </div>


                <div class="box-section title-box">

                    <p>
                        <img :src="poiDetail.LOGO" v-if="poiDetail.LOGO"/>
                        <b><span>{{poiDetail.NAME}}</span>&nbsp;&nbsp;<span>{{poiDetail.floorName}}层</span></b>
                    </p>

                    <p v-if="poiDetail.distance || poiDetail.lng || poiDetail.lat">
                        <span class="distant" v-if="poiDetail.distance">{{poiDetail.distance}}米</span><span v-if="poiDetail.lng">经度：{{poiDetail.lng}}</span><span v-if="poiDetail.lat">纬度：{{poiDetail.lat}}</span>
                    </p>

                    <p v-if="poiDetail.address || poiDetail.CATEGORY_NAME">
                        <span class="label" v-if="poiDetail.CATEGORY_NAME">{{poiDetail.CATEGORY_NAME}}</span><span>{{poiDetail.address}}</span><span><button  ref="copy" id="copy_txt"  :data-clipboard-text="poiDetail.address" @click="copy"><i class="iconfont icon-copy"></i></button></span>
                    </p>

                    <div class="btn-box">

                        <a @click="collected" v-if="!poiDetail.collected && $mapFunManger.collectAndFoots"><i class="iconfont icon-collection-o"></i><span>收藏位置</span></a>
                        <a @click="collected" class="active" v-else-if="poiDetail.collected && $mapFunManger.collectAndFoots" ><i class="iconfont icon-yishoucang"></i><span>已收藏</span></a>

                        <a @click="sharePint"><i class="iconfont icon-share"></i><span>分享位置</span></a>
                        <a :href="'tel:'+poiDetail.tel" v-if="poiDetail.tel"><i class="iconfont icon-dianhua"></i><span>电话</span></a>
                    </div>
                </div>


                <div class="box-section time-box" v-if="poiDetail.time">
                    <p>营业时间</p>
                    <p>{{poiDetail.time}}</p>
                    <p v-if="poiDetail.tel">电话  {{poiDetail.tel}}</p>
                </div>

                <div class="box-section praise-box" v-if="poiDetail.praise.length > 0">
                    <p>资质评价</p>
                    <div class="box">
                        <a v-for="(item,index) in poiDetail.praise">
                            <img :src="item.icon" alt="">
                            <span>{{item.name}}</span>
                        </a>
                    </div>
                </div>

                <div class="box-section lable-box" v-if="poiDetail.label.length>0">
                    <p>企业标签</p>
                    <div class="box">
                        <a :class="index <2 ? 'active':''" v-for="(item,index) in poiDetail.label">{{item.name}}</a>
                    </div>
                </div>

                <div class="box-section active-box" v-if="poiDetail.active.length>0">
                    <p>优惠活动</p>

                    <div class="box">

                        <div class="item" v-for="(item,index) in poiDetail.active" @click="activeDetail(item)">

                            <div class="wrap">

                                <div class="t-box" :state = "item.type">

                                    <label v-if="item.type == 0">企业活动</label>
                                    <label v-else>主题活动</label>

                                    <img :src="item.imgUrl" alt="">
                                </div>

                                <div class="b-box">

                                    <p>{{item.name}}</p>

                                    <div class="state-box">

                                        <div class="l-box" :state = "item.type">
                                            <span v-if="item.state == 1">即将进行</span>
                                            <span v-else>进行中</span>
                                        </div>

                                        <div class="r-box">

                                            <p v-if="item.state == 1 && item.type">{{item.endTime}}开始</p>
                                            <p v-else-if="item.type">{{item.endTime}}结束</p>

<!--                                            <i class="iconfont icon-weiguan"></i>-->
<!--                                            <span>{{item.Data.count}}</span>-->
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>


                <!--介绍-->
                <div class="box-section detail-box" v-if="poiDetail.shopDetail">

                    <p>企业详情</p>
                    <div class="box">{{poiDetail.shopDetail}}</div>
                </div>

            </div>


        </div>

    </div>

</template>

<script>

    import Clipboard from 'clipboard'
    import {getCollectData,addCollectData,deleteCollectData} from '@/config/prepare.js';
    import { Swipe, SwipeSlide } from '@/components/swipe'
    import index from "../../../../../components/message";
    import { Login } from '@/modules/login'

    window.$oldPoint = '';

    export default {
        name: "PoiDetailGather",

        data(){

            return {

                show:false,

                swipeOptions: {
                    continuous: false,
                    disableScroll: true,
                    disableIOSScroll: true,
                    callback: (i) => {
                        this.swipeIndex = i;
                    }
                },
                swipeIndex: 0,

                poiDetail:{
                    LOGO:'',
                    NAME:'',
                    floorName:'',
                    slideIMG:[],
                    distance:0,
                    address:'',
                    time:'',
                    tel:'',
                    praise:[],
                    label:[],
                    //0即将开始 1进行中 type 0店铺活动 1主题活动
                    active:[],
                    shopDetail:'',
                    collected:false,
                }
            }
        },


        methods:{
            slidIMG(item){},

            back(){
                this.show =false;
                this.$mapStep.type = 'selectePOI';
            },

            collected(){    //收藏

                if(this.poiDetail.collected){   //已收藏

                    let $id = this.$store.state.CollectData.filter((item,index,self)=>{
                        return JSON.parse(item.poi).POI_ID == this.poiDetail.poi.POI_ID
                    })[0].id;


                    deleteCollectData(this,$id,(res)=>{

                        this.$message.info('已取消收藏');
                        this.poiDetail.collected = false;

                        getCollectData(this,($res)=>{   //更动数据

                            if($res.data.code == 0){

                                this.$store.state.CollectData = $res.data.result;

                            }
                        })

                    })

                }else{  //未收藏

                    addCollectData(this,this.poiDetail.poi,(res)=>{

                        this.$message.info('收藏成功！在首页侧边栏或搜索页查看');
                        this.poiDetail.collected = true;

                        getCollectData(this,($res)=>{   //更动数据

                            if($res.data.code == 0){

                                this.$store.state.CollectData = $res.data.result;

                            }
                        })

                    })

                }

            },

            copy(){ //复制
                let $this = this,
                    clipboard = new Clipboard('#copy_txt');

                clipboard.on('success', e => {

                    $this.$message.info('复制成功')

                    // 释放内存
                    clipboard.destroy()
                })

                clipboard.on('error', e => {

                    $this.$message.info('复制失败')

                    // 释放内存
                    clipboard.destroy()
                })
            },

            activeDetail(item){

                this.$store.state.ACTIVITY_DATA_DETEIL = item.Data;

                this.$BRT.$active.enterActiveDetail = 1;

                if(item.type == 0){ //店铺活动

                    this.$router.replace('/details/1/'+item.Data.id);

                }else{  //主题活动
                    this.$router.replace('/details/2/'+item.Data.id);
                }
            },

            getRoute(){

                this.show =false;
                this.$BRT.$selecte.endPoint = this.poiDetail.poi;
                this.$BRT.$route.enterType = 'poiDetail';
                this.$mapStep.type = 'planRoute';


                if(this.$BRT.$locate.point){

                    this.bus.$emit('startAndEnd',{type:2});

                }else{

                    this.$BRT.$route.selectType.type ='location';
                    this.$BRT.$selecte.startPoint = '';
                    // this.bus.$emit('openLocation');

                }


            },


            sharePint(){//分享
                this.bus.$emit('shareCallback',{status:1,shareInfo:this.poiDetail.poi})
            }

        },


        components: {
            Swipe,
            SwipeSlide
        },

        mounted(){

            /**$oldPoint防止其他返回**/
            let $point = this.$store.state.mapStore.brtmap.$selecte.point ? this.$store.state.mapStore.brtmap.$selecte.point : $oldPoint,

                collected = this.$store.state.CollectData.some((item)=>{
                    return JSON.parse(item.poi).POI_ID == $point.poi.POI_ID
                })

            $oldPoint = $point;

            $point.collected = collected;

            this.poiDetail = $point;
            this.poiDetail= Object.assign({}, this.poiDetail, $point)
            this.show = true;
        }
    }
</script>

<style lang="less">
    @import "PoiDetailGather.less";
</style>
